import React  from 'react';
import { createStyles, makeStyles} from "@material-ui/core";
import LoadingIndicator from './UtilComponents/LoadingIndicator';

const useStyles = () => makeStyles(() =>
    createStyles({
        loading: {
            width: "4em",
            height: "100%",
            margin: "auto",
        }
    }));

const MapBoxLoadingIndicator: React.FC = () => {
    const classes = useStyles()();

    return (<LoadingIndicator className={classes.loading} />);
};

export default MapBoxLoadingIndicator;
